import { render, staticRenderFns } from "./CreateDiscountAdditionModal.vue?vue&type=template&id=e7d5e1e8"
import script from "./CreateDiscountAdditionModal.vue?vue&type=script&lang=js"
export * from "./CreateDiscountAdditionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports